import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import {
  AnonymousRoute,
  AuthenticatedRoute,
  HybridRoute,
  ForgotPasswordPage,
  ForgotPasswordConfirmPage,
  LoginPage,
  RegisterPage,
  ResetPasswordPage,
} from './shared';
import Account from './Account';
import Dashboard from './Dashboard';
import AnonDashboard from './Dashboard/AnonDashboard';
import OfferOverview from './OfferOverview';
import OfferPreview from './OfferPreview';
import Privacy from './Privacy';
import Terms from './Terms';
import OfferDisclaimer from './OfferDisclaimer';
import RepublicOffer from './RepublicOffer';
import WefunderOffer from './WefunderOffer';
import RealexOffer from './RealexOffer';

const Routes = () => (
  <Switch>
    <AnonymousRoute exact path='/login' component={LoginPage} />
    <AnonymousRoute exact path='/register' component={RegisterPage} />
    <AnonymousRoute
      exact
      path='/forgot-password'
      component={ForgotPasswordPage}
    />
    <AnonymousRoute
      exact
      path='/forgot-password-confirm'
      component={ForgotPasswordConfirmPage}
    />
    <AnonymousRoute
      exact
      path='/reset-password'
      component={ResetPasswordPage}
    />
    <AnonymousRoute exact path='/' component={AnonDashboard} />
    <AuthenticatedRoute path='/dashboard' component={Dashboard} />
    <AuthenticatedRoute path='/account' component={Account} />
    <HybridRoute exact path='/offer/:id' component={OfferOverview} />
    <AuthenticatedRoute
      exact
      path='/offer-disclaimer'
      component={OfferDisclaimer}
    />
    <Route exact path='/terms' component={Terms} />
    <Route exact path='/privacy' component={Privacy} />
    <Route exact path='/offer-preview/:id' component={OfferPreview} />
    <Route exact path='/republic/:id' component={RepublicOffer} />
    <Route exact path='/wefunder/:id' component={WefunderOffer} />
    <Route exact path='/realex/:id' component={RealexOffer} />
    <Route component={() => <Redirect to='/login' />} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js